import React, { Component } from "react";
import { Redirect, Route, Router, Switch } from "react-router-dom";

import history from "./utils/history";
import Login from "./pages/account/Login";
import PageWrapper from "./containers/PageWrapper";
import UserList from "./pages/user/UserList";
import CarrierClaim from "./pages/reference-tools/CarrierClaim";
import PaymentInfo from "./pages/reference-tools/PaymentInfo";
import StartApplicationPage from "./pages/start-application/StartApplicationPage";
import ReferenceToolsPage from "./pages/reference-tools/ReferenceToolsPage";
import DirectCarrierServicing from "./pages/reference-tools/DirectCarrierServicing";
import DirectCarrierLinks from "./pages/reference-tools/DirectCarrierLinks";
import BorRequests from "./pages/reference-tools/BorRequests";
import Home from "./pages/home/Home";
import RouteWithLayout from "./components/RouteWithLayout";
import AppetiteSearch from "./pages/appetite-search/AppetiteSearch";
import LeadForm from "./pages/lead-form/LeadForm";
import ThankYou from "./pages/lead-form/ThankYou";
import FourPanel from "./four-panel/FourPanel";
import Documents from "./pages/clients/Documents";
import acord from "./pages/reference-tools/Acord";
import { YourClients } from "./pages/clients/YourClients";
import { ExpiringPolicies } from "./pages/clients/ExpiringPolicies";
import { Quotes } from "./pages/clients/Quotes";
import { FinishApplication } from "./pages/clients/FinishApplication";
import Agencies from "./pages/account/Agencies";
import ServiceRequests from "./pages/service-requests/ServiceRequests";
import ResetPassword from "./pages/account/ResetPassword";
import ChangePassword from "./pages/account/ChangePassword";
import LicensingError from "./pages/lead-form/LicensingError";
import Error404 from "./pages/errors/Error404";
import Error503 from "./pages/errors/Error503";
import { CollectPaymentPage } from "./pages/collect-payment/CollectPaymentPage";
import RequestQuoteChangePage from "./pages/request-quote-change/RequestQuoteChangePage";
import { Orders } from "./pages/orders/Orders";
import { ValidationContext } from "./validation/ValidationContext";
import { createValidationErrorsObject } from "./validation/validation-provider";
import EditApplicationContainer from "./pages/policy-actions/EditApplicationContainer";
import { SurplusLinesSubmitBindRequest } from "./pages/policy-actions/SurplusLinesSubmitBindRequest";

class AppRouter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bindRequest: {},
      validationContext: {},
    };
  }

  hideServerValidationError(field) {
    var newObj = this.state.validationContext;
    newObj[field] = undefined;

    this.setState({ validationContext: newObj });
  }

  applyBindRequest(request) {
    this.setState({ bindRequest: request });
  }

  onServerValidationErrors(errors) {
    this.setState({
      validationContext: createValidationErrorsObject(errors),
    });
  }

  render() {
    return (
      <Router history={history}>
        <ValidationContext.Provider
          value={{
            backErrors: this.state.validationContext,
            hideError: (f) => this.hideServerValidationError(f),
          }}
        >
          <Switch>
            <RouteWithLayout
              layout={PageWrapper}
              path="/login"
              allowUnauthorized={true}
              backgroundType={"login"}
              exact
              component={Login}
              onServerValidationErrors={(e) => this.onServerValidationErrors(e)}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/reset-password"
              allowUnauthorized={true}
              exact
              component={ResetPassword}
              onServerValidationErrors={(e) => this.onServerValidationErrors(e)}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/changepassword/:token"
              allowUnauthorized={true}
              exact
              component={ChangePassword}
              onServerValidationErrors={(e) => this.onServerValidationErrors(e)}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/login-a"
              exact
              component={Agencies}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/home"
              showMenu={true}
              exact
              backgroundType={"home"}
              component={Home}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/appetite-search"
              showMenu={true}
              exact
              component={AppetiteSearch}
            />
            {/* <RouteWithLayout
              layout={PageWrapper}
              path="/lead-form"
              showMenu={true}
              exact
              component={LeadForm}
              onServerValidationErrors={(e) => this.onServerValidationErrors(e)}
            /> */}
            <RouteWithLayout
              layout={PageWrapper}
              path="/licensing-error"
              showMenu={true}
              exact
              component={LicensingError}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/service-request/:id"
              showMenu={true}
              exact
              component={ServiceRequests}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/client/:id/request-quote-change"
              showMenu={true}
              exact
              component={RequestQuoteChangePage}
              onServerValidationErrors={(e) => this.onServerValidationErrors(e)}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/client/:clientId/orders"
              showMenu={true}
              exact
              component={Orders}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/client/:clientId/edit-application"
              showMenu={true}
              component={EditApplicationContainer}
              onServerValidationErrors={(e) => this.onServerValidationErrors(e)}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/thank-you"
              component={ThankYou}
            />
            <RouteWithLayout path="/user-list" exact component={UserList} />
            <RouteWithLayout
              layout={PageWrapper}
              path="/start-application"
              showMenu={true}
              exact
              component={StartApplicationPage}
            />
            <RouteWithLayout
              layout={PageWrapper}
              showMenu={true}
              path="/reference-tools/carrier"
              exact
              component={CarrierClaim}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/reference-tools/payment"
              showMenu={true}
              exact
              component={PaymentInfo}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/reference-tools/bor"
              showMenu={true}
              exact
              component={BorRequests}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/reference-tools/direct-carrier"
              showMenu={true}
              exact
              component={DirectCarrierServicing}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/reference-tools/direct-carrier-links"
              showMenu={true}
              exact
              component={DirectCarrierLinks}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/reference-tools/acord"
              showMenu={true}
              exact
              component={acord}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/reference-tools"
              showMenu={true}
              exact
              component={ReferenceToolsPage}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/client/:clientId/:quoteIdToOpen"
              showMenu={true}
              exact
              component={FourPanel}
              onApplyBindRequest={(request) => this.applyBindRequest(request)}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/client/:clientId"
              showMenu={true}
              exact
              component={FourPanel}
              onApplyBindRequest={(request) => this.applyBindRequest(request)}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/your-clients"
              showMenu={true}
              exact
              component={YourClients}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/client/:clientId/documents"
              showMenu={true}
              exact
              component={Documents}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/expiring-policies"
              showMenu={true}
              exact
              component={ExpiringPolicies}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/quotes"
              showMenu={true}
              exact
              component={Quotes}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/finish-application"
              showMenu={true}
              exact
              component={FinishApplication}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/collect-payment"
              showMenu={true}
              exact
              bindRequest={this.state.bindRequest}
              component={CollectPaymentPage}
            />
            <RouteWithLayout
              layout={PageWrapper}
              path="/submit-surplus-bind"
              showMenu={true}
              exact
              bindRequest={this.state.bindRequest}
              component={SurplusLinesSubmitBindRequest}
            />
            <Route exact path="/">
              <Redirect to="/home" />
            </Route>
            <RouteWithLayout
              layout={PageWrapper}
              exact
              path="/error-503"
              component={Error503}
            />
            <RouteWithLayout layout={PageWrapper} component={Error404} />
          </Switch>
        </ValidationContext.Provider>
      </Router>
    );
  }
}

export default AppRouter;
